module.exports = __webpack_public_path__ + "checkmark-482a24f029dd77c58a6db62d153bca39.svg";